// ArtworkListItem.js — card risultato image-first (miniatura IIIF)
import React from 'react';
import { useLanguage } from '../../LanguageContext';
import './artwork.scss';

const ArtworkListItem = ({ artwork, isActive, handleClick, onHover }) => {
  const handleClickEvent = () => {
    handleClick();
  };

  const { selectedLanguage } = useLanguage();
  const getLangContent = (content) => content ? content[selectedLanguage === 'it' ? 'it_IT' : 'en_GB'] : '';

  // datazione sintetica per l'item: testo libero o range numerico
  const firstDate = (artwork.dates || [])[0];
  const dateLabel = firstDate
    ? (getLangContent(firstDate.date)
       || [firstDate.data_inizio, firstDate.data_fine].filter(Boolean).join(' – '))
    : '';

  return (
    <li
      className={`list-group-item itemArtwork ${isActive ? 'active' : ''}`}
      onClick={handleClickEvent}
      onMouseEnter={() => onHover && onHover(artwork.id)}
      onMouseLeave={() => onHover && onHover(null)}
    >
      <div className="artworkThumb">
        {artwork.cover_picture_id ? (
          <img
            src={`/iiif/2/${artwork.cover_picture_id}/full/!400,400/0/default.jpg`}
            alt={getLangContent(artwork.name)}
            loading="lazy"
          />
        ) : (
          <span className="artworkThumbPh" aria-hidden="true">
            <span className="phIcon">🏛</span>
            <span className="phText">
              {selectedLanguage === 'it' ? 'Immagine non disponibile' : 'No image available'}
            </span>
          </span>
        )}
      </div>
      <div className="artworkMeta">
        <div className="artworkMetaPlace">
          {[artwork.location?.city_town, artwork.location?.name_off].filter(Boolean).join(', ')}
        </div>
        <div className="artworkMetaName">
          {getLangContent(artwork.name)}
        </div>
        {dateLabel && (
          <div className="artworkMetaDate">
            🕐 {dateLabel}{(artwork.dates || []).length > 1 ? ' …' : ''}
          </div>
        )}
      </div>
    </li>
  );
};

export default ArtworkListItem;
